/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { Search, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { usePaymentContext } from "../../../../context/Payment/PaymentContext";

const Overview = () => {
  const [paymentList, setPaymentList] = useState([]);
  const { payment, fetchPayments, count } = usePaymentContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!payment) fetchPayments(page, pageSize);
    else setPaymentList(payment);
  }, [payment]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (payment !== null && payment !== undefined)
      payment.map((pay) => {
        if (pay?.name.toString().toLowerCase().includes(key))
          return searchArray.push(pay);
        return true;
      });

    setPaymentList(searchArray);
    if (key === "") setPaymentList(payment);
  };

  const totalsByCurrency =
    Array.isArray(paymentList) && paymentList.length
      ? paymentList.reduce((acc, p) => {
        const cur = p?.currency || "";
        const amt = Number(p?.amount) || 0;
        acc[cur] = (acc[cur] || 0) + amt;
        return acc;
      }, {})
      : {};

  return (
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-7xl">
        <div className="mb-3 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Payments
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Transactions and billing details
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Total items: {typeof count === "number" ? count : paymentList?.length || 0}
            </span>
          </div>
        </div>

        <div className="mb-4">
          <Search
            props={{
              title: "Payment",
              onChange: (e) => SearchList(e),
            }}
          />
        </div>

        {/* Sticky current total bar */}
        <div className="sticky top-0 z-20 mb-3 rounded-xl border border-gray-200 bg-white/90 px-4 py-3 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-white/70">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-xs font-semibold tracking-wide text-gray-700">
              Current Total:
            </span>
            {Object.keys(totalsByCurrency).length > 0 ? (
              Object.entries(totalsByCurrency).map(([cur, amt]) => (
                <span
                  key={cur || "default"}
                  className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-900 ring-1 ring-inset ring-gray-200"
                >
                  <span className="font-mono tabular-nums">
                    {cur || "—"} {Number(amt).toFixed(2)}
                  </span>
                </span>
              ))
            ) : (
              <span className="inline-flex items-center rounded-full bg-gray-100 px-3 py-1 text-xs font-semibold text-gray-900 ring-1 ring-inset ring-gray-200">
                <span className="font-mono tabular-nums">0.00</span>
              </span>
            )}
          </div>
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50/80">
                  <th className="w-1/5 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Title
                  </th>
                  <th className="w-1/5 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Content Details
                  </th>
                  <th className="w-1/5 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Amount
                  </th>
                  <th className="w-1/5 min-w-fit border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Payment Info
                  </th>
                  <th className="w-1/5 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Status
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {paymentList
                  ? paymentList?.map((payment, key) => (
                    <tr
                      key={key}
                      className="align-top transition-colors hover:bg-gray-50 odd:bg-white even:bg-gray-50/30"
                    >
                      <td className="px-4 py-3">
                        <div className="text-gray-900 font-medium break-words">
                          <span className="mr-1 inline-flex rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wide text-gray-700 ring-1 ring-inset ring-gray-200">
                            {payment?.content_type?.replace(/-/g, " ")}
                          </span>
                          {payment?.content_name}
                        </div>
                      </td>

                      <td className="px-4 py-3 text-gray-700">
                        <div className="whitespace-pre-line break-words">
                          <span className="text-xs text-gray-500">Start Date: </span>
                          <span>{payment?.start_date}</span>
                          <br />
                          <span className="text-xs text-gray-500">Start Time: </span>
                          <span>{payment?.start_time}</span>
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        <div className="font-semibold tracking-tight font-mono tabular-nums whitespace-nowrap">
                          {payment?.currency} {Number(payment?.amount).toFixed(2)}
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        <div className="text-gray-900 font-medium uppercase">
                          {payment?.card_type || "-"}{" "}
                          <span className="text-gray-400">•</span>{" "}
                          {payment?.card_last_4digits || "-"}{" "}
                          <span className="text-gray-400">•</span>{" "}
                          {payment?.card_expiry_date || "-"}
                        </div>
                        <div className="text-xs text-gray-500 break-words">
                          {payment?.tx_ref}
                        </div>
                      </td>

                      <td className="px-4 py-3">
                        {payment?.status_message === "successful" ? (
                          <span className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
                            Successful
                          </span>
                        ) : payment?.status_message === "pending" ? (
                          <span className="inline-flex items-center rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700 ring-1 ring-inset ring-amber-200">
                            Pending
                          </span>
                        ) : (
                          <span className="inline-flex items-center rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-medium text-red-700 ring-1 ring-inset ring-red-200">
                            {payment?.status_message || "failed"}
                          </span>
                        )}
                        <div className="mt-1 text-xs text-gray-500 font-mono tabular-nums whitespace-nowrap">
                          {new Date(String(payment?.createdAt)).toUTCString()}
                        </div>
                      </td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchPayments(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Overview;
